import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { RootState } from '@/store/index';
import { setTimeline } from '@/store/slices/timeline/timelineSlice';
import { setScreenWidth } from '@/store/slices/common/screenWidthSlice';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';

import { getTimelineApiCall } from '@/services/api';
import MiniNav from '@/components/common/miniNav/miniNav'
import TimelineMainView from '@/pages/timeline/main/view'

import TimeLineData from '@/dummyData/timeline.json'

import '@/styles/commonContainer.css'
import { handleUpdateUserPurchaseContentApiCall, handleUpdateWelcomeSeriesContentApiCall } from '@/utils/apiUtils';
import Footer from '@/components/common/footer';
import FloatingSupportButtons from '@/components/common/floatingSupportButtons';
import { allPaths } from '@/constants/urlPaths';
import { Toaster } from 'sonner';
import { addCurrentThemeClassToEle } from '@/utils';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';

export default function TimelineMain() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const { timeline } = useLocalTranslation();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    const { topSafeComponent } = useSafeAreaInsets();
    useEffect(() => {
        getTimelineDetails();
    }, []);


    useEffect(() => {
        dispatch(setScreenWidth(window.innerWidth));
        const handleResize = () => {
            dispatch(setScreenWidth(window.innerWidth));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    const getTimelineDetails = async () => {
        let noPurchaseound = false
        const purchaseId = window.location.href.split('/').pop();
        if (purchaseId) {
            const paylaod = {
                "purchaseId": purchaseId
            }
            const handleUpdateUserPurchaseContentApiCallStatus = await handleUpdateUserPurchaseContentApiCall(paylaod)
            const handleUpdateWelcomeSeriesContentApiCallStatus = await handleUpdateWelcomeSeriesContentApiCall(paylaod)
            if (handleUpdateUserPurchaseContentApiCallStatus && handleUpdateWelcomeSeriesContentApiCallStatus) {
                const timelineDetails = await getTimelineApiCall(purchaseId);
                if (timelineDetails.data && timelineDetails.status) {
                    setIsLoading(false);
                    dispatch(setTimeline(timelineDetails.data));
                    // console.log("timelineDetails : ",timelineDetails.data)

                    //@ts-ignore
                    // dispatch(setTimeline(TimeLineData.data)); // For testing dummy data
                    // console.log("duumy : ",TimeLineData.data)
                    // dispatch(setTimeline({})); // For testing empty state
                } else {
                    noPurchaseound = true
                }
            }
        } else {
            noPurchaseound = true
        }

        if (noPurchaseound) {
            // navigate(allPaths.dashboard);
            console.log("debug")
        }
    }

    const handleRedirectFromMiniNav = () => {
        navigate(allPaths.dashboard);
    }

    return (
        <div
            className={`font-roboto timelineIndex 
             ${addCurrentThemeClassToEle(currentTheme, 'timelineIndex')}`}>
            {topSafeComponent}
            <MiniNav
                navItemName={timeline.heading}
                redirectTo={handleRedirectFromMiniNav}
            />

            {/* 54px is the height is mini nav bar 
                28px is the pt as per figma
            */}
            <div className='commonContainer mt-[120px] min-[1280px]:mt-[45px] pt-[28px] pb-[125px] min-[856px]:pb-[30px]'>
                <TimelineMainView
                    isLoading={isLoading}
                />
            </div>
            {/* <Footer /> */}
            <FloatingSupportButtons />
            <Toaster richColors />

        </div>
    );
}
